import { render, staticRenderFns } from "./video-player-back.vue?vue&type=template&id=3a582c28&scoped=true&"
import script from "./video-player-back.vue?vue&type=script&lang=js&"
export * from "./video-player-back.vue?vue&type=script&lang=js&"
import style0 from "./video-player-back.vue?vue&type=style&index=0&id=3a582c28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a582c28",
  null
  
)

export default component.exports